import { render, staticRenderFns } from "./MainDemo.vue?vue&type=template&id=4eb36eee&"
import script from "./MainDemo.vue?vue&type=script&lang=js&"
export * from "./MainDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports